


















import Vue from 'vue'
import { IOfficeHourDay } from '@/api/types/response.types'

export default Vue.extend({
  name: 'MailboxSettingsOfficeHoursTooltip',

  props: {
    officeHourDays: {
      type: Array as () => IOfficeHourDay[],
      default: (): IOfficeHourDay[] => [],
    },
  },
})
